// extracted by mini-css-extract-plugin
export default {"mobileNav":"styles_mobileNav__0wxie","sidebarToggle":"styles_sidebarToggle__GQqor","navToggle":"styles_navToggle__0Wm5t","icon":"styles_icon__3Mr+J"};